import { ValidatorFn } from '@angular/forms';

export function duplicatedDirective<T>(supplier: () => Array<T>): ValidatorFn {
  return (control) => {
    return supplier().includes(control.value) ? { duplicated: { value: control.value } } : null;
  };
}
